'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: '현재 서비스를 이용할 수 없습니다. 잠시 후 다시 시도하십시오.',
    NEED_ACTIVE: '귀하의 계정 {{account}}은(는) 이 웹사이트를 처음 이용합니다. 작업을 계속하려면 {{activeLink}}를 통해 활성화를 완료하고 이 페이지로 돌아오세요',
    GOTO_ACTIVE: '지금 활성화하기',
    NOT_ACTIVED: '계정이 활성화되지 않았으므로 {{activeLink}}를 통해 활성화를 완료하세요.',
    COMPLETE_ACTIVE: '활성화 확인',
    FORBID_ACTIVE: '이 계정은 AliExpress에서 지원되지 않습니다!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: '다른 계정으로 로그인 해주세요',
    ACTIVE_PAGE: '계정 활성화 페이지로 가기'
};